import { useEffect } from "react";
import { usePatchPortfolioLoansMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioLoansMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getLoansFormSchema } from "web_myplann/Portfolio/Forms/LoansForm/loansFormSchema";
import { mapPortfolioToLoansForm } from "web_myplann/Portfolio/Forms/LoansForm/mapPortfolioToLoansForm";
import { withOwnLoanChange } from "web_myplann/Portfolio/Helpers/withOwnLoanChange";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditLoansFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditLoansForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditLoansFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPortfolioLoansMutation(portfolioId);

	const { form, onSubmit, leaveConfirmation } = useEditPortfolioForm({
		schema: getLoansFormSchema(t),
		defaultValues: mapPortfolioToLoansForm(portfolio),
		mutate: (portfolioFields, options, values) =>
			mutate(withOwnLoanChange(portfolioFields, values.change), options),
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
		isPending,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending, leaveConfirmation };
};
